// extracted by mini-css-extract-plugin
export default {"installButtonWrapper":"styles_installButtonWrapper__kH8wC","cards":"styles_cards__kn1i7","cardWrapper":"styles_cardWrapper__in42G","characteristics":"styles_characteristics__CjACT"};